import request from '@/libs/http/index'

export interface PaymentMethodVO {
  id?: number
  code: string
  name: string
  status: boolean
  sort: number
  builtIn: boolean
  canManage: boolean
}

export interface PaymentMethodSaveVO {
  id?: number
  name: string
  status: boolean
  sort: number
}

export const getPaymentMethodList = (enabledOnly = false) => {
  return request.get({
    url: '/clinic/payment-method/list',
    params: { enabledOnly },
  })
}

export const createPaymentMethod = (data: PaymentMethodSaveVO) => {
  return request.post({
    url: '/clinic/payment-method/create',
    data,
  })
}

export const updatePaymentMethod = (data: PaymentMethodSaveVO) => {
  return request.put({
    url: '/clinic/payment-method/update',
    data,
  })
}
